import { CommonModule, DecimalPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from 'src/app/shared/utils/translateUtils';
import { MaterialModule } from './../material/material.module';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { FormFieldErrorComponent } from './components/form-field-error/form-field-error.component';
import { SelectColumnsComponent } from './components/select-columns/select-columns.component';
import { CreatorTypeLabelPipe } from './pipes/creator-type-label.pipe';
import { GenderPipe } from './pipes/gender.pipe';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { MessageStatusFormatPipe } from './pipes/message-status-format.pipe';
import { OpenNowPipe } from './pipes/open-now.pipe';
import { PhonePipe } from './pipes/phone.pipe';
import { WorkingDayPipe } from './pipes/working-day.pipe';

@NgModule({
  declarations: [],
  providers: [DecimalPipe],
  imports: [
    CommonModule,
    MaterialModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorPageComponent,
    FormFieldErrorComponent,
    SelectColumnsComponent,
    CreatorTypeLabelPipe,
    GenderPipe,
    LocalizedDatePipe,
    MessageStatusFormatPipe,
    OpenNowPipe,
    PhonePipe,
    WorkingDayPipe,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    MaterialModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorPageComponent,
    FormFieldErrorComponent,
    SelectColumnsComponent,
    CreatorTypeLabelPipe,
    GenderPipe,
    LocalizedDatePipe,
    MessageStatusFormatPipe,
    OpenNowPipe,
    PhonePipe,
    WorkingDayPipe,
    TranslateModule
  ]
})
export class SharedModule {}
